<template>
    <fieldset
        class="lni-c-input-list"
        :class="{
            'lni-u-flex-column': orientation === 'column',
            '--required': required
        }"
    >
        <legend class="lni-c-input-list__legend">{{ labelText }}</legend>
        <slot />
        <div
            :id="controlId"
            class="lni-u-flex"
        >
            <div
                class="lni-c-radio"
                v-for="option in options"
                v-bind:key="option.value"
            >
                <input
                    :id="controlId + '_' + option.value"
                    class="lni-c-radio__input"
                    :name="controlId"
                    type="radio"
                    :value="option.value"
                    v-on:change="onInput"
                />
                <label
                    :for="controlId + '_' + option.value"
                    class="lni-c-radio__label">
                    <span>{{option.text}}</span>
                </label>
            </div>
        </div>
    </fieldset>
</template>

<script>
import framework from '../../framework';
/**
 *  The x-radio component.
 *  @module components/x-radio
 */


/**
 * The x-radios is a basic radio button list.
 */

export default {
    name: 'x-radios',
    mixins: [
        framework.mixins.abstractSingleValueInput,
    ],
    props: {
        dataOptions: Array,
        dataOrientation: String,
        dataLabelText: String,
    },
    mounted() {
        this.initialize();
    },
    computed: {
        /**
         * The text for the label.
         * @returns {string} label text.
         */
        labelText() {
            return this.getAttribute('labelText', '');
        },

        /**
         * The list of radio button options
         * @returns {*} array of options.
         */
        options() {
            return this.getOptions();
        },

        /**
         * Whether the radio button list is horizontal or vertical.
         * row (default) | column
         * @returns {string} orientation value.
         */
        orientation() {
            return this.getAttribute('orientation', 'row');
        },
    },

    methods: {
        /**
         * Handles the input event and sets the changed value onto the component's model.
         * @param {*} event the input event
         * @returns {void}
         */
        onInput(event) {
            this.value = event.target.value;
            this.handleErrorState();

            if (framework.utils.isFunction(this.onChangeFunction)) {
                this.onChangeFunction();
            }
        },

        /**
         * Gets the error information off of the input element(s)
         * @returns {void}
         */
        getErrorStateOffInputs() {
            let message = this.required && !this.componentValue
                ? 'Please fill out this field.'
                : '';
            return this.createValidationPayload(message);
        },
        /**
         * Put the values onto the Html Inputs
         * @returns {void}
         */
        initializeHtmlInputs() {
            if (this.componentValue) {
                let el = this.$el.querySelector(`input#${this.controlId}_${this.componentValue}`);
                el.checked = true;
            }
        },

    },
};
</script>

<style lang="scss">
    @import
        "../../styles/settings.scss",
        "radio.scss";
    .lni-c-input-list__legend {
        @include type-setting(-1);
    }
</style>



// WEBPACK FOOTER //
// source/components/x-radios/x-radios.vue